export enum GenderTypes {
    male = 'male',
    female = 'female',
    other = 'other',
}
